import { Building2, X } from "lucide-react";
import React from "react";

function ViewBranchDataByID({ viewBranchData, setViewBranchData }) {
  if (!viewBranchData) return null;

  return (
    <div className="fixed inset-0 overflow-hidden z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={() => setViewBranchData(null)}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      />

      {/* Modal */}
      <div className="relative max-h-[calc(100%-80px)] overflow-y-auto bg-white w-[95%] max-w-3xl rounded-2xl shadow-2xl p-8">
        {/* Header */}
        <div className="relative flex items-center justify-between bg-gradient-to-r from-blue-200 to-white p-2 sm:p-6 rounded-2xl shadow-sm border border-gray-100 mb-6">
          {/* Left Section */}
          <div className="flex items-center gap-5">
            {/* Avatar / Image */}
            <div className="relative w-16 h-16 sm:w-24 sm:h-24 rounded-2xl overflow-hidden shadow-md border border-gray-200 bg-white flex items-center justify-center">
              {viewBranchData?.imageUrl ? (
                <img
                  src={viewBranchData.imageUrl}
                  alt="Branch"
                  className="w-full h-full object-cover"
                />
              ) : (
                <Building2
                  className="w-10 h-10 text-blue-500"
                  strokeWidth={1.8}
                />
              )}
            </div>

            {/* Title Section */}
            <div className="flex flex-col">
              <span className="text-xs uppercase tracking-widest text-gray-400 font-medium">
                Branch Details
              </span>

              <h2 className="text-xl sm:text-3xl font-bold text-gray-800 leading-tight">
                {viewBranchData?.hospitalName}
              </h2>
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={() => setViewBranchData(null)}
            className="absolute top-4 -right-6 sm:top-4 sm:right-4 bg-white border border-gray-200 rounded-full p-2 text-gray-400 hover:text-red-500 hover:shadow-md transition-all duration-200"
          >
            <X className="w-5 h-5" strokeWidth={2} />
          </button>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
          <div>
            <p className="text-gray-500">Hospital Name</p>
            <p className="font-medium text-gray-800">
              {viewBranchData?.hospitalName}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Hospital ID</p>
            <p className="font-medium text-gray-800">
              {viewBranchData?.hospitalId}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Email</p>
            <p className="font-medium text-gray-800">
              {viewBranchData?.hospitalEmail}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Phone</p>
            <p className="font-medium text-gray-800">
              {viewBranchData?.hospitalPhone}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500">Full Address</p>
            <p className="font-medium text-gray-800">
              {viewBranchData?.hospitalFullAddress}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Status</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                viewBranchData?.isActive === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {viewBranchData?.isActive === 1 ? "Active" : "Inactive"}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Deleted</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                viewBranchData?.isDeleted === 1
                  ? "bg-red-100 text-red-600"
                  : "bg-blue-100 text-blue-700"
              }`}
            >
              {viewBranchData?.isDeleted === 1 ? "Yes" : "No"}
            </span>
          </div>

          {viewBranchData?.deactivatedAt && (
            <div>
              <p className="text-gray-500">Deactivated At</p>
              <p className="font-medium text-gray-800">
                {new Date(viewBranchData.deactivatedAt).toLocaleString()}
              </p>
            </div>
          )}

          {viewBranchData?.deletedAt && (
            <div>
              <p className="text-gray-500">Deleted At</p>
              <p className="font-medium text-gray-800">
                {new Date(viewBranchData.deletedAt).toLocaleString()}
              </p>
            </div>
          )}

          <div>
            <p className="text-gray-500">Created At</p>
            <p className="font-medium text-gray-800">
              {new Date(viewBranchData?.created_at).toLocaleString()}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Updated At</p>
            <p className="font-medium text-gray-800">
              {new Date(viewBranchData?.updated_at).toLocaleString()}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500">Branch UUID</p>
            <p className="font-mono text-xs text-gray-600 break-all">
              {viewBranchData?.id}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={() => setViewBranchData(null)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewBranchDataByID;